import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Avatar, Button, Col, Row, Tooltip } from "antd";
import PlayButton from "../../Components/PlayButton/PlayButton";
import Hashtag from "../../Components/Hashtag/Hashtag";
import ColorThief from "colorthief";
import "./MetadataDetail.css";
import {
  setAudioLinks,
  setAudioListId,
  setCurrentAudioIndex,
  setPlayState,
  setShowFooter,
} from "../../Redux/AudioSlice";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faCircleExclamation,
  faComment,
  faEllipsis,
  faFileArrowDown,
  faHeart,
  faList,
  faMusic,
  faPaperclip,
  faPen,
  faPlay,
  faRetweet,
  faTableList,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import FollowButton from "../../Components/FollowButton/FollowButton";
import RecommentAndPolicy from "../../Components/RecommendArtistAndPolicy/RecommentAndPolicy";
import TrackItem from "../../Components/TrackItem/TrackItem";
import CommentTree from "../../Components/CommentTree/CommentTree";
import ReplyItem from "../../Components/CommentTree/ReplyItem/ReplyItem";
import TooltipOptions from "../../Components/TooltipOptions/TooltipOptions";
import WatchMoreText from "../../Components/WatchMoreText/WatchMoreText";

function MetadataDetail({ isAudioList }) {
  //isFromAudioList.type: playlist, album
  const dispatch = useDispatch();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  // data
  const { metadataId } = useParams();
  const [currentAudioListId, setCurrentAudioListId] = useState(null);
  const audioListId = useSelector((state) => state.audio.audioListId);
  const location = useLocation();
  const navigate = useNavigate();
  const { audioLinks } = location.state || {};
  // title background
  const imgTitleRef = useRef(null);
  const [gradientColors, setGradientColors] = useState(["#ffffff", "#000000"]);
  // title content
  const titleContentRef = useRef(null);
  const [showTitleToolTip, setShowTitleToolTip] = useState(false);
  // audio
  const isPlaying = useSelector((state) => state.audio.isPlaying);
  const [showMore, setShowMore] = useState(false);
  // authentication
  const isOwn = true;

  // set current id of audio list
  useEffect(() => {
    setCurrentAudioListId(metadataId);
  }, [metadataId]);
  // background color
  useEffect(() => {
    const image = imgTitleRef.current;
    const extractColors = (image) => {
      const colorThief = new ColorThief();
      const palette = colorThief.getPalette(image, 2); // Get top 2 colors
      if (palette) {
        const [color1, color2] = palette.map(
          ([r, g, b]) => `rgb(${r}, ${g}, ${b})`
        );
        setGradientColors([color1, color2]);
      }
    };
    if (image.complete) {
      extractColors(image);
    } else {
      image.onload = () => extractColors(image);
    }
  }, []);
  // Title .etc
  useEffect(() => {
    const checkOverflow = () => {
      const element = titleContentRef.current;
      if (element) {
        setShowTitleToolTip(element.scrollHeight > element.clientHeight);
      }
    };
    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  const handlePlayAudioList = () => {
    dispatch(setShowFooter(true));
    dispatch(setCurrentAudioIndex(0)); // Start from the first audio
    dispatch(setAudioLinks(audioLinks)); // Set the audio links array
    dispatch(setAudioListId(metadataId));
    dispatch(setPlayState(!isPlaying)); // Start playing
  };

  const handleShowMoreOptions = () => {
    setShowMore((prev) => !prev);
  };

  const handleNavigateProfile = () => {
    if (userInfo) {
      navigate(`/profile/${userInfo?.id}`);
    }
  };

  return (
    <>
      <Col
        span={18}
        offset={3}
        className="metadataDetail"
        style={{
          background: `linear-gradient(to bottom right, ${gradientColors[0]}, ${gradientColors[1]})`,
        }}
      >
        <Row>
          {/** Title header */}
          <Col span={14}>
            <div className="titleWrapperName">
              <Tooltip
                placement="right"
                title={showTitleToolTip ? "track list" : ""}
              >
                <span ref={titleContentRef} className="metaDetailTitle title">
                  album number {metadataId}
                </span>
              </Tooltip>
              <div className="titleNameAndTag">
                <span className="metaDetailTitle artist">name of someone</span>
              </div>
            </div>
          </Col>
          <Col span={4} className="metaDetailInfoWrapper">
            <div className="subInfo">
              <span className="metaDetailTitleText">3 months ago</span>
              <div className="metaDetailHashtagIconWrapper">
                <Hashtag title="Indie" />
                {!isAudioList && (
                  <FontAwesomeIcon size="xl" color="white" icon={faMusic} />
                )}
              </div>
            </div>
            <div className="playInfo">
              <PlayButton
                size="md"
                onClick={handlePlayAudioList}
                isPlaying={
                  currentAudioListId && audioListId === currentAudioListId
                    ? isPlaying
                    : false
                }
                disabled={!isAudioList}
              />
              {isAudioList && (
                <span className="metaDetailTitleText track">9 tracks</span>
              )}
            </div>
          </Col>
          <Col span={6} className="metaDetailImgTitleWrapper">
            <img
              ref={imgTitleRef}
              className="metaDetailImgTitle"
              src="https://png.pngtree.com/thumb_back/fh260/background/20230408/pngtree-powder-smoke-colorful-background-image_2164096.jpg"
              crossOrigin="anonymous"
            />
          </Col>
        </Row>
      </Col>
      {/** Body */}
      <Col span={12} offset={3}>
        <Row className="artistBioWrapper">
          <Col span={6}>
            <div className="artistBioInfo">
              <Avatar
                onClick={() => handleNavigateProfile("abc123")}
                size={130}
                style={{ cursor: "pointer" }}
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YXJ0aXN0fGVufDB8fDB8fA%3D%3D&w=1000&q=80"
              />
              <span
                onClick={() => handleNavigateProfile("abc123")}
                className="bioArtistName"
              >
                Playlists of someone which have very long name
              </span>
              <div className="bioArtistFollowWrapper">
                <span className="bioArtistFollowers">
                  <FontAwesomeIcon icon={faUserGroup} /> {1092}
                </span>
                <FollowButton isFollowing={false} />
              </div>
            </div>
          </Col>
          <Col span={18}>
            <div className="bioPlaylistArtistDesc">
              <div className="bioTags">
                {[...Array(3)].map((_, index) => (
                  <Hashtag
                    key={index}
                    title={`tag ${index + 1}`}
                    onClick={() => {}}
                  />
                ))}
              </div>
              <WatchMoreText
                textInput={
                  "Relax and focus with some of the best chill lo-fi beats our SC community recently created. Updates every Wednesday with popular tracks in Vietnam."
                }
                wordLength={200}
              />
              <div className="artistPlaylistsmallInfo">
                {!isAudioList && (
                  <span>
                    <FontAwesomeIcon icon={faPlay} /> {50}
                  </span>
                )}
                <span>
                  <FontAwesomeIcon icon={faHeart} /> {20}
                </span>
                {!isAudioList && (
                  <span>
                    <FontAwesomeIcon icon={faComment} /> {12}
                  </span>
                )}
                <span>
                  <FontAwesomeIcon icon={faRetweet} /> {5}
                </span>
              </div>
              <div className="artistPlaylistsBtns">
                <Button size="small" disabled>
                  <FontAwesomeIcon icon={faHeart} /> Thích
                </Button>
                {isOwn ? (
                  <Button size="small" disabled>
                    <FontAwesomeIcon icon={faPen} />
                    Chỉnh sửa
                  </Button>
                ) : (
                  <Button size="small" disabled>
                    <FontAwesomeIcon icon={faRetweet} />
                    Đăng lại
                  </Button>
                )}
                <Button size="small" disabled>
                  <FontAwesomeIcon icon={faPaperclip} />
                  Sao chép link
                </Button>
                {!isAudioList && (
                  <Button size="small" disabled>
                    <FontAwesomeIcon icon={faFileArrowDown} />
                    {"Tải miễn phí" || "Mua"}
                  </Button>
                )}
                <Tooltip
                  placement="rightTop"
                  color="whitesmoke"
                  overlayStyle={{ width: "200px" }}
                  open={showMore}
                  title={<MoreOptions />}
                >
                  <Button onClick={handleShowMoreOptions} size="small">
                    <FontAwesomeIcon icon={faEllipsis} />
                    Thêm
                  </Button>
                </Tooltip>
              </div>
              <div className="artistPlaylists">
                {isAudioList ? (
                  audioLinks.map((audioLink, index) => {
                    const indexNum = index + 1;
                    return (
                      <div key={index} className="audioFromPlaylist">
                        <span className="audioFromPlaylistNumber">
                          {index + 1}
                        </span>
                        <TrackItem
                          key={index}
                          trackIndex={index}
                          trackId={audioLink.audioId}
                          trackName={audioLink.link + " " + indexNum}
                          metadataId={metadataId}
                          artistName={
                            "names of some artist who make this together with make this line is very very very long"
                          }
                          img={`https://picsum.photos/20${index}/300`}
                          isFromPlaylist={true}
                          audioLinks={audioLinks}
                          audioLink={audioLink.link}
                        />
                      </div>
                    );
                  })
                ) : (
                  <>
                    <div className="commentAreaWrapper">
                      <ReplyItem isReplyCmt={false} />
                      <div className="commentTreeArea">
                        <CommentTree />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={1} className="borderSplitWrapper">
        <div className="contentBorderSplit"></div>
      </Col>
      <Col span={5}>
        <RecommentAndPolicy type={"inPlaylistPage"} />
      </Col>
    </>
  );
}

function MoreOptions() {
  return (
    <>
      <Row style={{ color: "black" }}>
        <TooltipOptions
          icon={faList}
          title="Thêm vào kế tiếp"
          endSecion={true}
        />
        <TooltipOptions
          icon={faTableList}
          title="Thêm vào playlist "
          endSecion={true}
        />
        <TooltipOptions
          icon={faCircleExclamation}
          title="Báo cáo "
          endSecion={false}
        />
      </Row>
    </>
  );
}

export default MetadataDetail;
